import * as types from '../constants/actionTypes';

const initialState = {
  categories: [],
  activeCategories: [],
  totalCount: 0,
  loading: false,
  error: null,
  editingCategory: null,
  creating: false,
  updating: false,
  fetchingActive: false,
  singleCategory: null,
  fetchingById: false
};

const productCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch All Product Categories
    case types.FETCH_PRODUCT_CATEGORIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_PRODUCT_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload.categories,
        totalCount: action.payload.totalCount,
        error: null
      };
    
    case types.FETCH_PRODUCT_CATEGORIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        categories: [],
        totalCount: 0
      };

    // Fetch Active Product Categories
    case types.FETCH_ACTIVE_PRODUCT_CATEGORIES_REQUEST:
      return {
        ...state,
        fetchingActive: true,
        error: null
      };
    
    case types.FETCH_ACTIVE_PRODUCT_CATEGORIES_SUCCESS:
      return {
        ...state,
        fetchingActive: false,
        activeCategories: action.payload.categories,
        error: null
      };
    
    case types.FETCH_ACTIVE_PRODUCT_CATEGORIES_FAILURE:
      return {
        ...state,
        fetchingActive: false,
        error: action.payload.error,
        activeCategories: []
      };

    // Get Product Category by ID
    case types.GET_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state,
        fetchingById: true,
        error: null
      };
    
    case types.GET_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchingById: false,
        singleCategory: action.payload.category,
        error: null
      };
    
    case types.GET_PRODUCT_CATEGORY_FAILURE:
      return {
        ...state,
        fetchingById: false,
        error: action.payload.error,
        singleCategory: null
      };

    // Create Product Category
    case types.CREATE_PRODUCT_CATEGORY_REQUEST:
      return {
        ...state,
        creating: true,
        error: null
      };
    
    case types.CREATE_PRODUCT_CATEGORY_SUCCESS:
      return {
        ...state,
        creating: false,
        categories: [...state.categories, action.payload.category],
        totalCount: state.totalCount + 1,
        error: null,
        editingCategory: null
      };
    
    case types.CREATE_PRODUCT_CATEGORY_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload.error
      };

    // Update Product Category
        case types.UPDATE_PRODUCT_CATEGORY_REQUEST:
          return {
            ...state,
            updating: true,
            error: null
          };
    
        case types.UPDATE_PRODUCT_CATEGORY_SUCCESS:
          return {
            ...state,
            updating: false,
            categories: state.categories.map(category =>
              category.id === action.payload.category.id
                ? action.payload.category
                : category
            ),
            error: null,
            editingCategory: null
          };
    
        case types.UPDATE_PRODUCT_CATEGORY_FAILURE:
          return {
            ...state,
            updating: false,
            error: action.payload.error
          };
    
        // Set Editing Category
    case types.SET_PRODUCT_CATEGORY_EDITING:
      return {
        ...state,
        editingCategory: action.payload.category
      };

    // Clear Editing Category
    case types.CLEAR_PRODUCT_CATEGORY_EDITING:
      return {
        ...state,
        editingCategory: null
      };

    default:
      return state;
  }
};

export default productCategoryReducer;